@for (section of sections | async; track section) {
  <div
    class="mt-4"
  >
    @if (section.config && section.results?.length && (section.config.readPermissions | hasRole)) {
      <app-tab-section
        [section]="section">
      </app-tab-section>
    }
    @if (!section.config) {
      <app-search-result-wrapper [results]="section.results"/>
      <app-search-filter-pagination [total]="section.total"/>
    }
  </div>
}
